import { Pill } from '@crazyegginc/hatch';
import { percentizeValue } from '../utils';

export function DeltaPill({ delta, positiveColor = 'green', negativeColor = 'red' }) {
  if (!Number.isFinite(delta)) return null;
  const value = percentizeValue(delta);
  const sign = Math.sign(delta);
  const color = sign === 1 ? positiveColor : negativeColor;

  if (sign === 0) return null;

  return (
    <Pill arrowIndicator={sign} colour={color}>
      {value}
    </Pill>
  );
}
